import React from 'react'
import CreditImg from '../../Images/CreditImg/LaghuBittiyaLoan.jpg'
import SideNavCredit from '../Navigation/SideNavCredit'
import Aos from 'aos'

const LaghuBittiyaLoan = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNavCredit />
                    </div>
                    <div className='d-body-main'>
                        <div className='saving-body-top' data-aos='fade-right'>
                            <h2>लघु वित्त आयआर्जन ऋण</h2>
                        </div>
                        <div className='saving-body' data-aos='fade-right'>
                            <div className='saving-main'>
                                <h3>विवरण :</h3>
                                <p>
                                    <ul>
                                        <li>संकेत नंः ११०.११</li>
                                        <li>ऋणको उद्देश्यः सदस्यहरूलाई लघुवित्त समुहको माध्यमबाट ऋण लगानी गरी आयआर्जनमा सहयोग गर्ने । </li>
                                        <li>ऋणको सिमाः अधिकतम रु.३ लाखसम्म </li>
                                        <li>ब्याजदरः संस्थाले तोके बमोजिम ।</li>
                                        <li>किस्ताः मासिक</li>
                                        <li>समयावधिः २ बर्ष</li>
                                        <li>धितो व्यवस्थाः समूह जमानी </li>
                                    </ul>
                                </p>

                            </div>
                            <div className='savingimg'>
                                <img src={CreditImg} alt='Credit-1' />
                            </div>
                        </div>
                        <div className='saving-footer' data-aos='fade-right'>
                            <h3>विशेषताहरू :</h3>
                            <p>
                                <ul>
                                    <li>सदस्यहरूलाई समूहको माध्यमबाट आय आर्जनको क्षेत्रमा लगानी गर्न सकिने । </li>
                                    <li>व्यवस्थापन शुल्क कुल ऋणको १% लाग्ने तथा ऋण सुरक्षण कोष वापत १% लाग्ने ।</li>
                                    <li>समयमा ऋण नतिरेमा भाखा नाघेको ऋणको किस्तामा ५% हर्जना लाग्ने ।</li>
                                    <li>ब्याज भाखा नाघेमा पहिलो महिना पाकेको ब्याजमा १८, दोस्रो महिना २०, तेस्रो महिना २२ र चौथो महिना २४ प्रतिशतले दैनिक गणनाको आधारमा हर्जना लाग्ने ।</li>
                                    <li>अग्रिम तिर्न सकिने ।</li>
                                    <li>सम्मान तथा पुरस्कार प्राप्त गर्न सकिने । </li>
                                    <li>भाखा ननघाई बुझाएको ब्याजलाई संरक्षित पूँजी फिर्ता कोषमा गणना गरीने ।</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default LaghuBittiyaLoan